export type EagleModules = Record<string, { default: Record<string, any> }>;

export type MergedExports = Record<string, any>;

export function mergeDynamicEagerDefaultExports(
	importedModules: EagleModules
): MergedExports {
	return Object.keys(importedModules).reduce<MergedExports>(
		(acc, key) => ({ ...acc, ...(importedModules[key]?.default || {}) }),
		{}
	);
}
